export default "__VITE_PUBLIC_ASSET__52f9e8e9__"